import { AgentChatErrorFallback } from '@/components/agent-chat/agent-chat-error-boundary.component';
import {
  useIsCopilotRoute,
  useIsHomeRoute,
} from '@/components/agent-chat/copilot-runtime-provider.component';
import { useAppSelector } from '@/store';
import { selectAiChatOpen } from '@/store/features/ui.feature';
import {
  DEFAULT_DOCK_WIDTH,
  dockCardClass,
  dockFrameClass,
} from './dock-frame';

/**
 * What the shell shows when the Clu dock itself crashes: the error in the
 * dock's own frame, where the dock stood (clear of the tabbed sidebar), or
 * nothing when the dock was closed or the page is Clu itself. It stands in
 * the same frame as the dock, so no page moves.
 */
export function AiSidebarFallback({ onRetry }: { onRetry: () => void }) {
  const isOpen = useAppSelector(selectAiChatOpen);
  const onCopilotRoute = useIsCopilotRoute();
  const onHomeRoute = useIsHomeRoute();
  const shown = isOpen && !onCopilotRoute && !onHomeRoute;

  if (!shown) return null;
  return (
    <div
      data-ai-sidebar-fallback
      className={dockFrameClass()}
      style={{ width: DEFAULT_DOCK_WIDTH }}
    >
      <div className={dockCardClass()}>
        <AgentChatErrorFallback onRetry={onRetry} />
      </div>
    </div>
  );
}
